import { render, staticRenderFns } from "./RelatorioCotasUnidade.vue?vue&type=template&id=0b51c6d6"
import script from "./RelatorioCotasUnidade.vue?vue&type=script&lang=js"
export * from "./RelatorioCotasUnidade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports